/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
import { hasFeature } from 'root/api/admin/features';
import { BreadcrumbsTypes } from 'root/breadcrumbs';
import mostUsedEmailDomains from 'root/email_domain';

window.cb_openlisting = function cb_openlisting(result) {
  const pannel = window.xGetElementById(result.pannel_id);
  window.clearWorking(pannel);

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (pannel.listing || pannel.view) {
    if (!window.breadcrumbs || window.breadcrumbs.length <= 0) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
      window.pushParent(pannel);
    } else {
      // Add listing to the breadcrumbs stack if it's not already there
      const lastParent = window.breadcrumbs[window.breadcrumbs.length - 1];
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      if (lastParent && lastParent.name !== result.ajax_listing.name) {
        // Need to set the type so that breadcrumbs works
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        result.ajax_listing.type = 'listing';
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'AjaxListing | undefined' is not ... Remove this comment to see the full error message
        window.breadcrumbs.push(result.ajax_listing);
      }
    }
  } else {
    const parents = window.breadcrumbs;
    if (parents && parents.length == 1) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      result.ajax_listing.type = 'listing';
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'AjaxListing | undefined' is not ... Remove this comment to see the full error message
      parents.push(result.ajax_listing);
    }
  }

  window.do_listingrefresh(result);
};
window.cb_refresh = function cb_refresh(result) {
  window.do_listingrefresh(result);
};

window.do_listingrefresh = function do_listingrefresh(result) {
  let pannel = window.getListingPannel(result.pannel_id);

  if (!pannel) return;

  $(pannel).addClass('is_pannel');
  window.clearWorking(pannel);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'clear' does not exist on type 'Partial<{... Remove this comment to see the full error message
  if (result.clear) {
    pannel = window.getListingPannel(result.pannel_id);
    if (!pannel) {
      window.finishAjaxRequest(result.pannel_id, result);
      return;
    }
    pannel.innerHTML = '';
    window.finishAjaxRequest(result.pannel_id, result);
    return;
  }

  if (!result.html || !pannel) {
    window.finishAjaxRequest(result.pannel_id, result);
    return;
  }

  pannel.current_type = 'listing';
  pannel.listing = result.ajax_listing;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
  pannel.listing_row_values = result.row_values;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
  if (!pannel.listing_tabs_loaded || !result.get_tab_only) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
    pannel.listing_tabs_loaded = [];
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
  pannel.listing_tabs_loaded[pannel.listing.tab] = true;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.deleted_rows = null;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'get_tab_only' does not exist on type 'Pa... Remove this comment to see the full error message
  if (result.get_tab_only) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
    const tab_pannel = window.xGetElementById(`${pannel.id}_${pannel.listing.tab}`);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'true | HTMLE... Remove this comment to see the full error message
    const tab_select = window.xGetElementById(`${pannel.id}_${pannel.listing.tab}_select`);

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (tab_pannel + tab_select) {
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      $(tab_select).addClass('current_tab');
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      tab_pannel.innerHTML = result.html;
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      tab_pannel.style.display = '';

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
      if (!pannel.listing_tabs_loaded) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
        pannel.listing_tabs_loaded = [];
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
      pannel.listing_tabs_loaded[result[2]] = true;
    }
  } else if (result.draw_all) {
    if (!pannel.parent_id) {
      // setup listing keys, unless this is a listing inside of a view
      window.subscribeListingKeys(pannel.id);
    }

    $(pannel).htmlReplace(result.html);

    // If pannel isn't visible then we're dealing with a top-level listing and
    // need to make #listing visible (and hide other top-level DOM objects).
    if ($(pannel).is(':hidden')) {
      // The panel can also be a listing inside a view, EX: Item > sales (listing all sales for item X)
      // In that case, the panel "reports_sales_listings_transaction_line_sales_view" is already visible
      window.merchantos.page.show(pannel.id);
    }
  } else {
    const work_pannel = window.xGetElementById(`work_${pannel.id}`);
    if (work_pannel) {
      // Cursor loses position when tabbing if table is recreated
      // This logic allow page to save the position and re-instert the cursor to the last position
      let cursorActiveInputId: string | null = null;
      const activeElement = document.activeElement;
      if (activeElement && ['INPUT', 'TEXTAREA'].includes(activeElement.tagName)) {
        cursorActiveInputId = activeElement.id;
      }

      work_pannel.innerHTML = result.html;

      if (cursorActiveInputId) {
        document.getElementById(cursorActiveInputId)?.focus();
      }
    }
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_link' does not exist on type 'Pa... Remove this comment to see the full error message
  if (result.listing_link) {
    const listing_link = $(`#${pannel.id}_l_link`)[0];
    if (listing_link) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'href' does not exist on type 'HTMLElemen... Remove this comment to see the full error message
      listing_link.href = result.listing_link;
    }
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.draw_all = false;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.draw_tab_only = false;

  window.clearFieldChanges(pannel);

  if (!pannel.parent_id) {
    window.setAutoFocus();
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'expand_form' does not exist on type 'Par... Remove this comment to see the full error message
  if (result.expand_form) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'pannelExpando' does not exist on type 'W... Remove this comment to see the full error message
    window.pannelExpando(`expando_${pannel.id}`, `${pannel.id}_side_${result.expand_form}`);
  }

  // Listing loaded in a #listing page
  if (!$(pannel).closest('.view_listing').length) {
    $('body,html').scrollTop(0);
    window.refreshPageHeader(pannel);
  }
  // Triggering a history change will mount/unmount react components.
  history.changeState();

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (pannel.listing.go_back) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    window.history.go(result.ajax_listing.go_back - 1);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    pannel.listing.go_back = false;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  window.setPageSelector(pannel.listing);

  window.finishAjaxRequest(pannel, result);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh_helper' does not exist on type '... Remove this comment to see the full error message
  if (result.refresh_helper) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh_helper' does not exist on type '... Remove this comment to see the full error message
    window.execRefreshHelper(result.refresh_helper, result.refresh_helper_args || []);
  }

  hasFeature('DataPanDetectionWarn').then((hasFeature) => {
    if (!hasFeature || !pannel) return;
    window.validateFieldsInContainer(pannel);
  });
};

/**
 * Calls a refresh helper for the listing.  The helper must be present
 * in the namespace.
 *
 * @param helper {String} The method to invoke
 * @param args {Array}  Arguments to pass to the refresh helper.
 */
window.execRefreshHelper = function execRefreshHelper(helper, args) {
  // traverse the namespace (if necessary) to retrieve
  // the function to call
  let helperFnc = window;
  // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
  // eslint-disable-next-line no-return-assign
  helper.split('.').forEach((object) => (helperFnc = helperFnc[object]));

  if (typeof helperFnc === 'function') {
    // eslint-disable-next-line @typescript-eslint/ban-types
    (helperFnc as Function).apply(helperFnc, args);
  }
};

window.cb_openviewrecord = function cb_openviewrecord(result) {
  const pannel_id = 'view'; // ignore result['pannel_id']
  const pannel = window.getViewPannel(pannel_id);
  if (!pannel) return;

  window.clearWorking(pannel);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'success' does not exist on type 'Partial... Remove this comment to see the full error message
  if (!result.success || !pannel) {
    window.finishAjaxRequest(result.pannel_id, result);
    return;
  }

  if (pannel.new_stored_listing) {
    pannel.stored_listing = pannel.new_stored_listing;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'new_stored_listing' does not exist on ty... Remove this comment to see the full error message
    pannel.new_stored_listing = false;
  }

  if (pannel.view_tabs_loaded) {
    pannel.view_tabs_loaded = [];
  }

  pannel.current_type = 'view';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
  pannel.view = result.ajax_view;

  window.pushParent(pannel);

  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
  window.merchantos.page.show('view', { html: result.html });

  window.setViewTitle(pannel);
  window.autoLoadListings(pannel, pannel.id);

  window.initCustomFields(pannel.view);

  window.subscribeViewKeys(pannel.id);

  window.clearFieldChanges(pannel);

  window.setAutoFocus();

  window.refreshPageHeader(pannel);
  $(pannel).trigger('viewready');
  window.finishAjaxRequest(pannel, result);
};

window.cb_editfield = function cb_editfield(result, format) {
  const pannel = window.getListingPannel(result.pannel_id);
  if (pannel && result.ajax_listing) pannel.listing = result.ajax_listing;

  if (result.refresh && result.pannel_id) {
    window.pushListingRefresh(result.pannel_id);
  }

  if (result.refresh_listing && result.pannel_id) {
    window.pushQueueRequest(result.pannel_id, () => window.RefreshListing(`${result.pannel_id}`));
  }

  if (result.pannel_id === 'purchase_listings_checkin_items_view') {
    window.isPOReceivdQtyBeingUpdated = false;
  }

  const field = result.field_id
    ? (window.xGetElementById(result.field_id) as HTMLInputElement)
    : null;
  if (field) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
    window.setFormFieldValue(field, result.value, format, result.pannel_id);
    if (result.refocus) {
      window.setFocus(field);
    }
  }

  window.finishAjaxRequest(result.pannel_id, result);
};

window.cb_dolistingfunction = function cb_dolistingfunction(result) {
  const pannel = window.getListingPannel(result.pannel_id);
  if (pannel && result.ajax_listing) {
    pannel.listing = result.ajax_listing;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'clean' does not exist on type 'Partial<{... Remove this comment to see the full error message
  if (result.clean) {
    window.clearFieldChanges(false);
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'success' does not exist on type 'Partial... Remove this comment to see the full error message
  if (result.success) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'return_to_parent' does not exist on type... Remove this comment to see the full error message
    if (result.return_to_parent) {
      // Do not add to request queue if present in ajax response
      if (!result.requests?.length) {
        window.pushQueueRequest(result.pannel_id, () =>
          window.returnToParent(`${result.pannel_id}`)
        );
      }
    } else {
      if (result.refresh && result.pannel_id) {
        window.pushListingRefresh(result.pannel_id);
      }
      if (result.refresh_listing && result.pannel_id) {
        window.pushQueueRequest(result.pannel_id, () =>
          window.RefreshListing(`${result.pannel_id}`)
        );
      }
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'remove_row' does not exist on type 'Part... Remove this comment to see the full error message
    if (result.remove_row) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
      window.removeListingRecord(result.pannel_id, result.row_num);
    }
    if (pannel) {
      window.listingSelectNone(pannel);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'return_to_parent' does not exist on type... Remove this comment to see the full error message
  } else if (result.return_to_parent) {
    // Do not add to request queue if present in ajax response
    if (!result.requests?.length) {
      window.pushQueueRequest(result.pannel_id, () => window.returnToParent(`${result.pannel_id}`));
    }
  }
  window.finishAjaxRequest(result.pannel_id, result);
};

window.subscribeListingKeys = function subscribeListingKeys(pannel_id) {
  window.merchantos.keyboard.subscribe('Alt+f', () => window.RefreshListing(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+r', () => window.RefreshListing(pannel_id));
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId' is not assignable to pa... Remove this comment to see the full error message
  window.merchantos.keyboard.subscribe('Alt+m', () => window.listingAdvancedSearch(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+c', () => window.returnToParent(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+pageup', () => window.pageGoTo('previous'));
  window.merchantos.keyboard.subscribe('Alt+pagedown', () => window.pageGoTo('next'));
  window.merchantos.keyboard.subscribe('Alt+home', () => window.pageGoTo('first'));
  window.merchantos.keyboard.subscribe('Alt+end', () => window.pageGoTo('last'));
};

window.pushListingRefresh = function pushListingRefresh(pannel_id) {
  const pannel = window.getRealPannel(pannel_id);
  if (!pannel) {
    window.pushQueueRequest(pannel_id, () => window.RefreshListing(`${pannel_id}`));
    return;
  }

  if (pannel.current_type == 'listing') {
    window.pushQueueRequest(pannel_id, () => window.RefreshListing(`${pannel.id}`));
    return;
  }
  window.pushQueueRequest(pannel.id, () => window.openView());
};

window.getListingPannelFromContext = function getListingPannelFromContext(context) {
  const pannel = $(context).closest('.is_pannel')[0];
  return window.getListingPannelGeneric(pannel);
};

window.getListingPannel = function getListingPannel(pannel_id) {
  const pannel = window.xGetElementById(pannel_id);
  return window.getListingPannelGeneric(pannel);
};

window.getListingPannelGeneric = function getListingPannelGeneric(pannel) {
  if (!pannel) {
    return;
  }

  if (!pannel.current_type) {
    if (pannel.listing) {
      pannel.current_type = BreadcrumbsTypes.Listing;
    } else if (pannel.view) {
      pannel.current_type = BreadcrumbsTypes.View;
    } else {
      pannel.current_type = undefined;
    }
  }

  if (!pannel.listing) {
    pannel.listing = {};
    pannel.listing.draw_all = true;
    pannel.listing.draw_tab_only = false;
  }

  return pannel;
};

/**
 * Opens a listing page in pannel_id.
 * @param {String} pannel_id
 * @param {String} name
 * @param {String} init_search
 * @param {String} tab
 * @returns {$.Deferred}
 * @constructor
 */
window.OpenListing = function OpenListing(pannel_id, name, init_search, tab) {
  const pannel = window.xGetElementById(pannel_id);
  const promise = $.Deferred();

  if (!pannel) return promise.resolve().promise();

  if (window.isWorking(pannel)) return promise.resolve().promise();

  window.saveOnChanges(pannel).done(() => {
    const listing: Partial<AjaxListing> = {};
    listing.draw_all = true;
    listing.draw_tab_only = false;
    listing.name = name;
    listing.request = window.getContextRequest(pannel_id);
    listing.saved_search = {};

    if (init_search.__sort) {
      listing.sort = init_search.__sort;
    }
    if (init_search.__sort_dir) {
      listing.sort_dir = init_search.__sort_dir;
    }

    let search = {};
    /*
     * init_search can be of two forms:
     * [
     *  ["key","value"],
     *  ["key2","value2"]
     * ]
     * or
     * {
     *  "key":"value",
     *  "key2":"value2"
     * }
     *
     * We want to convert format 1 into form 2
     */
    if (Array.isArray(init_search)) {
      $.each(init_search, (i, v) => {
        if (typeof i === 'number' && (i % 1 === 0 || i === 0)) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          search[v[0]] = v[1];
        } else {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          search[i] = v;
        }
      });
      listing.saved_search = search;
    } else if ($.isPlainObject(init_search)) {
      listing.saved_search = init_search;
      search = init_search;
    }

    window.setWorking(pannel);

    const content_map = {} as ContentMap;
    content_map.method = 'POST';
    content_map.form_name = 'listing.refresh';
    content_map.ajax_listing = window.toJsonString(listing);
    content_map.key_values = window.toJsonString(search);
    content_map.pannel_id = pannel.id;
    if (tab) {
      content_map.tab = tab;
    }

    window.doServerCall(content_map, window.cb_openlisting).always(() => promise.resolve());
  });

  return promise;
};

/**
 *
 * @param {Element} pannel_id
 * @returns {null|$.Deferred}
 * @constructor
 */
window.RefreshListing = function RefreshListing(pannel_id, refresh_inventory_count_filter) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  if (window.isWorking(pannel)) return;

  const deferred = $.Deferred();

  window.saveOnChanges(pannel).done(() => {
    window.fillSavedListingSearch(pannel);
    window.setWorking(pannel);

    const work_pannel = window.xGetElementById(`work_${pannel.id}`);

    if (!work_pannel) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
      pannel.listing.draw_all = true;
    }

    const content_map = {} as ContentMap;

    // CLD-4140 Reset the user settings for the search field in inventory count on new count
    if (refresh_inventory_count_filter) {
      pannel.listing!.name = 'inventory_count.listings.inventory_count_items';
      content_map.refresh_inventory_count_filter = true;
    }

    content_map.method = 'POST';
    content_map.form_name = 'listing.refresh';
    content_map.ajax_listing = window.toJsonString(pannel.listing);
    content_map.key_values = window.toJsonString(pannel.listing!.saved_search);
    content_map.pannel_id = pannel.id;
    window
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'cb_refresh'.
      .doServerCall(content_map, !refresh_inventory_count_filter && cb_refresh)
      .always(() => deferred.resolve());
  });

  return deferred;
};

window.restrictCustomerSearch = function (form_id: string, isRegisterSearch = false) {
  window.Monitoring.addEvent(
    'register_transaction.search_customer',
    'Register transaction searching customer',
    {}
  );
  const EMAIL_WITH_ONLY_DOMAINS = /^@([\w-]+\.)+[\w-]{1,8}$/;
  const toggleSearchErrorMsg = ({
    targetElement,
    errMessage,
    identifier,
    closestParent,
    tag,
  }: {
    targetElement: JQuery<HTMLElement>;
    closestParent?: string;
    tag?: string;
    identifier: string;
    errMessage?: string;
  }) => {
    if (errMessage && closestParent && tag) {
      targetElement
        .addClass(identifier)
        .closest(closestParent)
        .append(`<${tag} class=${identifier} id=${identifier}>${errMessage}</${tag}>`);
    } else {
      $(`#${identifier}`).remove();
      targetElement.removeClass(identifier);
    }
  };
  const MIN_CUSTOMER_NAME_LENGTH = 2;
  let isRestricted = false;

  if (!window.lsCloud.Modules.hasModule('customer.search.optimized_search')) return isRestricted;

  const { form_name, tab } = window.history.getFilters();

  const input = form_id
    ? $(`#${form_id}`).find(
        isRegisterSearch
          ? 'input[name="find_customer"]'
          : 'input[name="customer_name"], input[name="customer_search"]'
      )
    : null;

  if (
    !input?.is(':visible') ||
    (form_name !== 'listing' && tab !== 'customers' && !isRegisterSearch)
  ) {
    return isRestricted;
  }

  const searchValue = (input?.val() as string)?.trim() as string;
  const identifier = 'search-customer-error';
  const closestParent = isRegisterSearch ? '.register-customer' : 'ul.search-fields';
  const tag = isRegisterSearch ? 'div' : 'li';

  toggleSearchErrorMsg({ targetElement: input, identifier });

  if (searchValue && searchValue.length < MIN_CUSTOMER_NAME_LENGTH) {
    const errMessage = `Enter at least ${MIN_CUSTOMER_NAME_LENGTH} characters to search`;
    toggleSearchErrorMsg({
      targetElement: input,
      closestParent,
      identifier,
      tag,
      errMessage,
    });

    isRestricted = true;
  }

  if (
    searchValue?.toLowerCase().match(EMAIL_WITH_ONLY_DOMAINS) &&
    mostUsedEmailDomains?.has(searchValue?.toLowerCase()?.split('@')?.[1])
  ) {
    const errMessage = 'Search needs to be more specific. Try again.';
    toggleSearchErrorMsg({
      targetElement: input,
      closestParent,
      identifier,
      tag,
      errMessage,
    });

    isRestricted = true;
  }

  return isRestricted;
};

window.PageControlListing = function PageControlListing(pannel) {
  if (!pannel) {
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  pannel.listing.draw_tab_only = true;
  window.RefreshListing(pannel);
};

window.openListingRowNum = function openListingRowNum(pannel_id, row_num) {
  const rec_num = window.getRecNum(pannel_id, row_num);
  window.openListingRecordNum(pannel_id, rec_num, row_num);
};

window.openListingRecordNum = function openListingRecordNum(pannel_id, rec_num, row_num) {
  const listing_pannel = window.getListingPannel(pannel_id);
  const view_pannel = window.getViewPannel('view');

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (view_pannel.view.stored_listing) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    view_pannel.stored_listing = view_pannel.view.stored_listing;
  }

  if (!listing_pannel || !view_pannel) return;

  if (window.isWorking(view_pannel)) return;

  window.saveOnChanges(view_pannel).done(() => {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    view_pannel.view.rec_num = rec_num;

    window.setWorking(view_pannel);

    const content_map = {} as ContentMap;

    // if we have a row_num then get the row value str
    let has_row_values = false;
    let row_values: any;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
    if (row_num !== undefined && listing_pannel.listing_row_values) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
      row_values = listing_pannel.listing_row_values[row_num];
      has_row_values = true;
    }

    // if we are getting this from a listing then store the listing info
    if (has_row_values) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      view_pannel.view.count = listing_pannel.listing.count;
      view_pannel.new_stored_listing = listing_pannel.listing;
    } else {
      if (view_pannel.stored_listing) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        view_pannel.view.count = view_pannel.stored_listing.count;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'new_stored_listing' does not exist on ty... Remove this comment to see the full error message
      view_pannel.new_stored_listing = false;
    }

    content_map.form_name = 'listing.openviewrecord';
    content_map.ajax_view = window.toJsonString(view_pannel.view);
    if (has_row_values) {
      content_map.row = window.toJsonString(row_values);
    } else {
      content_map.ajax_listing = window.toJsonString(view_pannel.stored_listing);
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      content_map.key_values = window.toJsonString(view_pannel.stored_listing.saved_search);
    }
    content_map.pannel_id = 'view';
    window.doServerCall(content_map, window.cb_openviewrecord);
  });
};

window.openListingRecordView = function openListingRecordView(pannel_id, name, row_num, tab) {
  const pannel = window.getViewPannel('view');

  if (!pannel) {
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (pannel.view.name != name) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.tab = false;
  }
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  pannel.view.name = name;
  if (tab) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.tab = tab;
  }
  window.openListingRowNum(pannel_id, row_num);
};

window.listingSearch = function listingSearch(pannel_id, form_id) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel || window.restrictCustomerSearch(form_id)) {
    return;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.user_search = true;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.page = 1;

  window.refreshSavedListingSearch(pannel);

  const deferred = window.RefreshListing(pannel);

  const button = pannel.querySelector('#searchButton');
  if (deferred && button) {
    // Track multiple clicks & visually disable button
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    window.merchantos.sidebar.xhrStarted(pannel.listing.name, button, deferred);
  }
};

$(document).on('click', '.listing .navigate a', function onListingNavClick(event) {
  event.preventDefault();

  // Parse Href for action
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const action = $(this).attr('href').replace('#', '');

  switch (action) {
    case 'page_size':
      window.listingUserPageSize(this);
      break;
    default:
      window.pageGoTo(this, action);
      break;
  }

  return false;
});

window.pageGoTo = function pageGoTo(context, page) {
  const pannel = window.getListingPannelFromContext(context);

  // eslint-disable-next-line default-case
  switch (page) {
    case 'first':
      page = '1';
      break;
    case 'previous':
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      page = parseInt(pannel.listing.page, 10) - 1;
      break;
    case 'next':
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      page = parseInt(pannel.listing.page, 10) + 1;
      break;
    case 'last':
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      page = parseInt(pannel.listing.page_count, 10);
      break;
    case 'record':
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      const record = parseInt(prompt('What record would you like to view?'), 10);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      page = Math.ceil(record / pannel.listing.page_size);
      break;
  }

  // Validate pannel and page are supplied
  if (!pannel || !page) {
    return false;
  }

  // Set page equal to one if it's less than 1
  if (Number(page) < 1) {
    page = 1;
  }

  // Don't let user go past end of pages
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (page > pannel.listing.page_count) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    page = pannel.listing.page_count;
  }

  // If we're already on that page don't refresh listing
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (pannel.listing.page == page) {
    return;
  }

  // Change pannel setting and re-render
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.page = page;
  window.PageControlListing(pannel);
};

window.listingUserPageSize = function listingUserPageSize(context) {
  const pannel = window.getListingPannelFromContext(context);
  let promptText = 'How many results per page would you like to display?';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  if (pannel.listing.max_size !== 5000) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
    promptText += `\nLimit ${pannel.listing.max_size}`;
  }
  const size = prompt(promptText);
  if (size && pannel) {
    window.setPageSize(pannel, parseInt(size, 10));
  }
};

window.setPageSize = function setPageSize(pannel, size) {
  if (!pannel || isNaN(size)) {
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (size <= 0 || size > pannel.listing.max_size) {
    alert(`Page size not set. Invalid page size: ${size}`);
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (pannel.listing.page_size == size) {
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  pannel.listing.page_size = size;
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  pannel.listing.page = 1;

  window.PageControlListing(pannel);
};

$(document).on('change', 'select.pageNum', (event) => {
  const page = event.target[event.target.selectedIndex].value;
  window.pageGoTo(event.target, page);
});

// Function called when a page with a listing on it is reloaded via browser controls
window.listingReloaded = function listingReloaded(retry) {
  if (!retry) {
    retry = 0;
  }
  const pannel_id = $('#listing')[0];
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  window.fillSavedListingSearch(pannel);
  const listing = pannel.listing!;
  if (!listing.page && retry < 40) {
    window.setTimeout(() => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      retry += 1;
      listingReloaded(retry);
    }, 50);
  } else if (listing.page) {
    window.setPageSelector(listing as AjaxListing);

    // Register customers is opened in a uniquely weird way
    // Set up breadcrumbs for this particular listing
    if (listing.name == 'customer.listings.register_customers') {
      window.merchantos.register.addRegisterParent();
      window.pushParent(pannel);

      window.refreshPageHeader('listing');
    }
  }
};

// Set the page selector that allows a user to jump to a range of rows
window.setPageSelector = function setPageSelector(listing) {
  const $select = $('select.pageNum');
  let firstPage: number;
  let lastPage: number;
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  if (listing.page_count <= 20 || listing.page <= 10) {
    firstPage = 2;
    if (listing.page_count <= 20) {
      lastPage = listing.page_count - 1;
    } else {
      lastPage = 20;
    }
  } else {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number | null' is not assignable... Remove this comment to see the full error message
    firstPage = parseInt(listing.page, 10) - 9;
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number | null' is not assignable... Remove this comment to see the full error message
    lastPage = parseInt(listing.page, 10) + 10;
  }
  $select.append('<option>...</option>');

  for (let i = firstPage; i <= lastPage; i++) {
    const firstRow = listing.page_size * (i - 1) + 1;
    let lastRow = listing.page_size * i;
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    if (lastRow >= listing.count) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'number | null' is not assignable to type 'nu... Remove this comment to see the full error message
      lastRow = listing.count;
    }
    let option: string;
    if (i == listing.page) {
      option = `<option selected value="${i}">`;
    } else {
      option = `<option value="${i}">`;
    }
    option += `${firstRow} - ${lastRow}`;
    option += '</option>';
    $select.append(option);
  }
  $select.append('<option value="record">Jump to #</option>');
};

$(document).on('click', '.is_pannel .listing th a.sort', function onClickListingPanel(event) {
  event.preventDefault();

  const searchParams = window.merchantos.utils.getQueryParams(this.href);
  const pannel = $(this).closest('.is_pannel')[0];

  const sort_by_field = searchParams.__sort;
  const sort_direction = searchParams.__sort_dir;

  if (sort_by_field == pannel.listing.sort && sort_direction == pannel.listing.sort_dir) {
    return;
  }

  pannel.listing.sort = sort_by_field;
  pannel.listing.sort_dir = sort_direction;
  pannel.listing.page = 1;

  // @TODO - Figure this out at some point. Why do we have sort and __sort?
  // pannel.listing.saved_search.__sort = sort_by_field;
  // pannel.listing.saved_search.__sort_dir = sort_direction;

  window.PageControlListing(pannel);

  // Triggers preventDefault on click/touch event
  return false;
});

window.listingEditField = function listingEditField(field_id, ids, pannel_id, format_type) {
  const field = window.xGetElementById(field_id);
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const col = field.name;
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
  const value = window.getFormFieldValue(field);
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  field_id = field.id;

  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  if ($(pannel).closest('.view_listing').length) {
    window.clearViewTabs();
  }

  if (pannel_id === 'purchase_listings_checkin_items_view') {
    window.isPOReceivdQtyBeingUpdated = true;
  }

  const content_map = {} as ContentMap;
  content_map.method = 'POST';
  content_map.form_name = 'listing.editfield';
  content_map.ajax_listing = window.toJsonString(pannel.listing);
  content_map.col = col;
  content_map.ids = ids;
  content_map.value = value;
  content_map.field_id = field_id;
  content_map.pannel_id = pannel.id;

  window.doServerCall(content_map, (result) => window.cb_editfield(result, format_type));
};

window.cb_update_serial = function cb_update_serial(result) {
  const pannel = window.getListingPannel(result.pannel_id);
  if (pannel && result.ajax_listing) pannel.listing = result.ajax_listing;

  if (result.refresh && result.pannel_id) {
    window.pushListingRefresh(result.pannel_id);
  }

  window.finishAjaxRequest(result.pannel_id, result);
};

window.listingAssignItemSerial = function listingAssignItemSerial(
  pannel_id: any,
  transaction_line_id: any,
  customer_id: any,
  serialized_id: any,
  skip_listing_refresh: boolean = false
) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  const content_map = {} as ContentMap;
  content_map.method = 'POST';
  content_map.form_name = 'serialized.assign_serial';
  content_map.ajax_listing = window.toJsonString(pannel.listing);
  content_map.pannel_id = pannel.id;
  content_map.transaction_line_id = transaction_line_id;
  content_map.customer_id = customer_id;
  content_map.serialized_id = serialized_id;
  window.doServerCall(content_map, skip_listing_refresh ? undefined : window.cb_update_serial);
};

window.listingRemoveItemSerial = function listingRemoveItemSerial(pannel_id, serialized_id) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  const content_map = {} as ContentMap;
  content_map.method = 'POST';
  content_map.form_name = 'serialized.delete_serial';
  content_map.ajax_listing = window.toJsonString(pannel.listing);
  content_map.pannel_id = pannel.id;
  content_map.serialized_id = serialized_id;
  window.doServerCall(content_map, window.cb_update_serial);
};

window.doListingFunction = function doListingFunction(pannel_id, fnc, row_num) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) {
    return false;
  }
  if (window.isWorking(pannel)) {
    return false;
  }

  if (window.merchantos.interrupt.isBlocked('listing.dofunction')) {
    window.merchantos.interrupt.push('listing.dofunction', () =>
      window.doListingFunction(pannel_id, fnc, row_num)
    );
    return false;
  }
  window.merchantos.interrupt.block('listing.dofunction');

  const selected_records = window.getSelectedRecords(pannel);

  window.fillSavedListingSearch(pannel);
  pannel.listing!.row_num = row_num;
  pannel.listing!.rec_num = window.getRecNum(pannel, row_num);

  let row_values = false;
  if (row_num >= 0) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
    row_values = pannel.listing_row_values[row_num];
  }

  const content_map = {} as ContentMap;
  content_map.method = 'POST';
  content_map.form_name = 'listing.dofunction';
  content_map.ajax_listing = window.toJsonString(pannel.listing);
  content_map.fnc = fnc;
  content_map.key_values = window.toJsonString(pannel.listing!.saved_search);
  content_map.row = window.toJsonString(row_values);
  content_map.selected_records = window.toJsonString(selected_records);
  content_map.pannel_id = pannel.id;

  // If we error out during a listing function, we need to free this key
  $.when(
    window.doServerCall(content_map, window.cb_dolistingfunction, { flushAjaxMessages: true })
  ).then(() => {
    if (window.merchantos.interrupt.isBlocked('listing.dofunction')) {
      window.merchantos.interrupt.free('listing.dofunction');
    }
  });

  return true;
};

window.removeListingRecord = function removeListingRecord(pannel_id, row_num) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  window.addDeletedRow(pannel, row_num);

  $(`#${pannel.id}_r_${row_num}`).hide();
};

window.clearSavedListingSearch = function clearSavedListingSearch(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (pannel.listing.saved_search) delete pannel.listing.saved_search;
};
window.fillSavedListingSearch = function fillSavedListingSearch(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (window.objectPropertyCount(pannel.listing.saved_search) === 0) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    pannel.listing.saved_search = window.getFormValues(`${pannel.id}_search`);
  }
};
window.refreshSavedListingSearch = function refreshSavedListingSearch(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'chart' does not exist on type 'true | HT... Remove this comment to see the full error message
  if (pannel.chart) {
    // we've changed the search so we need to reset the chart so we get all the data for it again
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'chart' does not exist on type 'true | HT... Remove this comment to see the full error message
    pannel.chart = null;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.saved_search = window.getFormValues(`${pannel.id}_search`);
};

window.getListingTab = function getListingTab(pannel_id, tab) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  pannel.listing.tab = tab;
  // pannel.listing.draw_tab_only = true;
  window.RefreshListing(pannel.id);
};

window.selectListingTab = function selectListingTab(pannel_id, to_tab) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
  if (!pannel.listing_tabs_loaded) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
    pannel.listing_tabs_loaded = [];
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
  pannel.listing_tabs_loaded[pannel.listing.tab] = true;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  const from_tab = pannel.listing.tab;

  if (to_tab == from_tab) return;

  const from_pannel = window.xGetElementById(`${pannel.id}_${from_tab}`);
  const from_select = window.xGetElementById(`${pannel.id}_${from_tab}_select`);

  const to_pannel = window.xGetElementById(`${pannel.id}_${to_tab}`);
  const to_select = window.xGetElementById(`${pannel.id}_${to_tab}_select`);

  if (from_pannel && from_select && to_pannel && to_select) {
    $(from_pannel).hide();
    $(from_select).removeClass('current_tab');

    if (!from_pannel.listing) from_pannel.listing = {};

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type 'Partial<{ ... Remove this comment to see the full error message
    from_pannel.listing.page = pannel.listing.page;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'page_count' does not exist on type 'Part... Remove this comment to see the full error message
    from_pannel.listing.page_count = pannel.listing.page_count;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
    from_pannel.listing.sort = pannel.listing.sort;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
    from_pannel.listing.sort_dir = pannel.listing.sort_dir;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
    from_pannel.listing_row_values = pannel.listing_row_values;

    try {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      delete pannel.listing.page;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      delete pannel.listing.page_count;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      delete pannel.listing.sort;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      delete pannel.listing.sort_dir;
      // eslint-disable-next-line no-empty
    } catch (e) {}

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_tabs_loaded' does not exist on t... Remove this comment to see the full error message
    if (pannel.listing_tabs_loaded[to_tab]) {
      to_pannel.style.display = '';
      $(to_select).addClass('current_tab');

      if (to_pannel.listing) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type 'Partial<{ ... Remove this comment to see the full error message
        if (to_pannel.listing.page) pannel.listing.page = to_pannel.listing.page;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'page_count' does not exist on type 'Part... Remove this comment to see the full error message
        if (to_pannel.listing.page_count) pannel.listing.page_count = to_pannel.listing.page_count;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
        if (to_pannel.listing.sort) pannel.listing.sort = to_pannel.listing.sort;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
        if (to_pannel.listing.sort_dir) pannel.listing.sort_dir = to_pannel.listing.sort_dir;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
        if (to_pannel.listing_row_values) pannel.listing_row_values = to_pannel.listing_row_values;
      }

      window.setAutoFocus(to_pannel);

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      pannel.listing.tab = to_tab;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      window.storePrefOnServer(pannel.listing.name, 'current_tab', pannel.listing.tab, pannel.id);

      window.showNotifier('working', 'Working...');
    } else {
      window.getListingTab(pannel, to_tab);
    }
  }
};

window.addDeletedRow = function addDeletedRow(pannel_id, row_num) {
  const pannel = window.getListingPannel(pannel_id);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  if (!Array.isArray(pannel.listing.deleted_rows)) pannel.listing.deleted_rows = [];
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  pannel.listing.deleted_rows.push(row_num);
};

window.getRowsDeletedBefore = function getRowsDeletedBefore(pannel_id, row_num) {
  const pannel = window.getListingPannel(pannel_id);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  if (!pannel.listing.deleted_rows) return 0;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  if (!Array.isArray(pannel.listing.deleted_rows)) return 0;

  let count = 0;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
  for (let i = 0; i < pannel.listing.deleted_rows.length; i++) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
    if (pannel.listing.deleted_rows[i] < row_num) count++;
  }
  return count;
};

window.getRecNum = function getRecNum(pannel_id, row_num) {
  const pannel = window.getListingPannel(pannel_id);

  if (!pannel) return 0;

  if (!pannel.listing) return 0;

  if (row_num < 0) return row_num;

  // adjust the row num based on how many rows have been removed above
  row_num -= window.getRowsDeletedBefore(pannel, row_num);

  return (
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    row_num + 1 + (parseInt(pannel.listing.page, 10) - 1) * parseInt(pannel.listing.page_size, 10)
  );
};

window.getRowNum = function getRowNum(pannel_id, rec_num) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return -1;

  if (!pannel.listing) return -1;

  if (rec_num < 0) return -1;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  const row_num = rec_num - 1 - (pannel.listing.page - 1) * pannel.listing.page_size;

  return row_num;
};

$(document).on('click', 'a.advanced_toggle', function onAdvancedToggleClick(e) {
  $(this).toggleClass('inactive').toggleClass('active');
  e.preventDefault();

  let toggleElement;

  if (e.target.classList.contains('customer_search_advanced_options')) {
    toggleElement = document.getElementById('customer_advanced_search_options');
  }

  window.listingAdvancedSearch($(this), toggleElement);
});

window.listingAdvancedSearch = function listingAdvancedSearch(toggler, toggleElement) {
  const form = toggler.closest('form');
  const pannel = $(`#${form?.data('pannel')}`)[0];
  let advanced;

  // When the form element is present the advanced toggle is rendered
  // using listing-column as part of the form
  // and when its absent its custom rendering via .tpl
  if (form.length) {
    advanced = form.find('.advanced');
  } else if (toggleElement) {
    advanced = $(toggleElement);
  }

  // Does pannel support advanced search?
  if (advanced) {
    // Is advanced visible?
    if (advanced.is(':visible')) {
      // Yes? Hide it.
      advanced.hide();

      if (pannel?.listing) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        pannel.listing.display_advanced = 0;
      }
      // Change toggle icon as well
      toggler.find('i').attr('class', 'icon-plus');
    } else {
      // No? Show it.
      advanced.show();

      if (pannel?.listing) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        pannel.listing.display_advanced = 1;
      }

      // Change toggle icon as well
      toggler.find('i').attr('class', 'icon-minus-sign');
    }

    if (pannel?.listing) {
      // Store on the server
      window.storePrefOnServer(
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        pannel.listing.name,
        'display_advanced',
        pannel.listing.display_advanced,
        $(pannel).attr('id')
      );
    }
  }
};

window.autoLoadListings = function autoLoadListings(p_pannel_id: any, parent_id: any) {
  const p_pannel = window.xGetElementById(p_pannel_id);
  if (!p_pannel) {
    return;
  }

  $.each($(p_pannel).find('.auto_load_listing'), (_index, listing) => {
    const name = listing.name;
    const id = window.getFormFieldValue(listing as HTMLInputElement);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | { [key: string]: string... Remove this comment to see the full error message
    const pannel = window.getListingPannel(id);

    if (!pannel) {
      return false;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    pannel.listing.name = name;

    if (parent_id) {
      pannel.parent_id = parent_id;
    }

    const setups = $(pannel).find(`.${id}_setup`);

    if (setups.length <= 0) {
      window.pushQueueRequest(p_pannel, () => window.RefreshListing(`${id}`));
      return true;
    }

    $.each(setups, (_index, setup) => {
      const value = window.getFormFieldValue(setup as HTMLInputElement);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
      pannel.listing[setup.name] = value;
    });

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
    if (pannel.listing.saved_search) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
      delete pannel.listing.saved_search;
    }

    window.pushQueueRequest(p_pannel, () => window.RefreshListing(`${id}`));
  });
};

$(document).on('change', 'input[type="checkbox"].toggle_all', function onCheckboxChange(event) {
  event.preventDefault();
  window.listingToggleAll(this);
});

window.listingToggleAll = function listingToggleAll(control) {
  const referenced_pannel = $(control).data('pannel');
  const checkboxes = $(`input.${referenced_pannel}_rec_sel`);

  if ($(control).is(':checked')) {
    checkboxes.prop('checked', true);
  } else {
    checkboxes.prop('checked', false);
  }
};

window.listingSelectNone = function listingSelectNone(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  const sel_class = `${pannel.id}_rec_sel`;

  const sels = window.custGetElementsByClassName(sel_class);
  for (let i = 0; i < sels.length; i++) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 4 arguments, but got 2.
    window.setFormFieldValue(sels[i], 'off');
  }
};

// @ts-expect-error ts-migrate(2322) FIXME: Type '(pannel_id: PanelId) => (string | undefined)... Remove this comment to see the full error message
window.getSelectedRecords = function getSelectedRecords(pannel_id) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return [];

  const sel_class = `${pannel.id}_rec_sel`;

  const selected_records = [];

  const sels = window.custGetElementsByClassName(sel_class);
  for (let i = 0; i < sels.length; i++) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
    // eslint-disable-next-line no-continue
    if (window.getFormFieldValue(sels[i]) !== 'on') continue;
    if (sels[i].name) selected_records.push(sels[i].name);
  }
  return selected_records;
};

window.drillIntoListing = function drillIntoListing(pannel_id, listing_name, row_num) {
  const pannel = window.getListingPannel(pannel_id);
  if (!pannel) return;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  if (!pannel.listing.saved_search) {
    window.refreshSavedListingSearch(pannel.id);
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'true | ... Remove this comment to see the full error message
  const search = pannel.listing.saved_search;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
  if (row_num !== undefined && pannel.listing_row_values) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing_row_values' does not exist on ty... Remove this comment to see the full error message
    // eslint-disable-next-line no-return-assign
    $.each(pannel.listing_row_values[row_num], (key, value) => (search[key] = value));
  }

  // @ts-expect-error ts-migrate(7034) FIXME: Variable 'init_search' implicitly has type 'any[]'... Remove this comment to see the full error message
  const init_search = [];
  $.each(search, (key, value) => init_search.push([key, value]));

  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'init_search' implicitly has an 'any[]' t... Remove this comment to see the full error message
  window.OpenListing(window.getRealPannel(pannel_id), listing_name, init_search);
};

window.saveTransactionLineItemSerialInfoForReinstatement =
  function saveTransactionLineItemSerialInfoForReinstatement(
    transaction_line_id: number,
    serialized_id: number
  ) {
    // When a transaction line has a serial number removed, but does not have a new one added before leaving the page,
    // we need to revert back to the removed serial number.
    // This is a bit tricky to do in the backend because there is no simple way to save the serial id between the removal and reverting
    // Instead, we embed some javascript to save the serial id against the line item id on the users local storage.
    //
    // Then, in the front-end if the leaves the page or reloads without a serial number present,
    // we reinstate it through `listingAssignItemSerial`, and remove the ids from local storage within the component `SerialsAutocomplete`.
    //
    // Save the serialized id in the format of: {<transaction_line_id>: <serialized_id>}

    const LOCAL_STORAGE_REMOVED_ITEM_SERIAL_ID_KEY = 'removedItemSerialID';

    const storedValue = localStorage.getItem(LOCAL_STORAGE_REMOVED_ITEM_SERIAL_ID_KEY);
    let serial_info = {} as { [key: number]: number };
    if (storedValue === null) {
      serial_info[transaction_line_id] = serialized_id;
    } else {
      serial_info = JSON.parse(storedValue);
      if (!(transaction_line_id in serial_info)) {
        serial_info[transaction_line_id] = serialized_id;
      }
    }

    localStorage.setItem(LOCAL_STORAGE_REMOVED_ITEM_SERIAL_ID_KEY, JSON.stringify(serial_info));

    // Avoid requiring two reloads to reinstate the serial number to the line item if the form's data has changed.
    // @ts-ignore
    window.oldConfirm = window.confirm;
    window.confirm = function () {
      return false;
    };
  };
